// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2NvOQ","log":"ModalInventoryLogs_log__3mBva","date":"ModalInventoryLogs_date__1Ks6a","userName":"ModalInventoryLogs_userName__3HZO7"};